import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/usr/src/app/www/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "summarize-spoken-text-template-sst"
    }}>{`Summarize Spoken Text Template (SST)`}</h1>
    <h2 {...{
      "id": "template-for-30---50"
    }}>{`Template for 30 -> 50`}</h2>
    <p>{`The lecturer talked about `}<strong parentName="p">{`{Topic}`}</strong>{`, which has become a controversial issue around the world.`}</p>
    <p>{`He firstly had a discussion on the problem of `}<strong parentName="p">{`{Topic}`}</strong>{` in `}<strong parentName="p">{`{N1}`}</strong>{` including `}<strong parentName="p">{`{N2}`}</strong>{` and `}<strong parentName="p">{`{N3}`}</strong>{`.`}</p>
    <p>{`Additionally, he highlighted the role of `}<strong parentName="p">{`{N4}`}</strong>{`, which may cause detrimental effects on `}<strong parentName="p">{`{N5}`}</strong>{`.`}</p>
    <p>{`In his closing argument, he called on people to take full responsibility in tackling the issue of
`}<strong parentName="p">{`{Topic}`}</strong>{`.`}</p>
    <h2 {...{
      "id": "template-for-65---79"
    }}>{`Template for 65 -> 79`}</h2>
    <p>{`The lecturer talked about `}<strong parentName="p">{`{N}`}</strong>{` + `}<strong parentName="p">{`{relative clause}`}</strong>{`.`}</p>
    <p>{`He firstly had a discussion on the problem of `}<strong parentName="p">{`{Clause}`}</strong>{`.`}</p>
    <p>{`Additionally, he highlighted that `}<strong parentName="p">{`{clause}`}</strong>{`.`}</p>
    <p>{`Finally, he concluded that `}<strong parentName="p">{`{clause}`}</strong>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      